exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dv5-multiline-slide-grid-h[data-v-44ed7c99]{-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch;justify-items:stretch;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-ms-flex-line-pack:stretch;align-content:stretch;-webkit-column-gap:.53vw;-moz-column-gap:.53vw;column-gap:.53vw;row-gap:.53vw;max-width:100%!important;width:100%!important;min-height:0!important;padding:0 .625rem!important}@media (max-width:701px){.dv5-multiline-slide-grid-h[data-v-44ed7c99]{row-gap:0!important;-webkit-column-gap:0!important;-moz-column-gap:0!important;column-gap:0!important;padding:0!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-44ed7c99","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/dashboard-v5/shared/MultilineSlideGridH.vue
// module id = 54N0
// module chunks = 0